module.exports = __webpack_public_path__ + "static/RobotoSlab700-ec7c1ae4cc932ee7dc511b070c147b21.ttf";